import { smartGuideFrontendSettings } from "../../Shared/webTranslations";

export function scopeWebIntegrationStorageKey(key: string): string {
    const integrationId = smartGuideFrontendSettings.integrationId;
    const destinationId = smartGuideFrontendSettings.integrationDestinationId;
    if (!integrationId || !destinationId) {
        return key;
    }

    const prefix = `integration:${integrationId}:${destinationId}:`;
    return key.startsWith(prefix) ? key : `${prefix}${key}`;
}
